import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './MainServices.css';
import homeBasedImage from '../images/services/homebased.jpeg';
import elderlyImage from '../images/services/eldercare.jpeg';
import palliativeImage from '../images/services/pallative.jpeg';
import doctorVisitImage from '../images/services/Doctor-Visit.png';
import elderly1Image from '../images/services/elderly1.png';
import labImage from '../images/services/labtest.jpg';

const MainServices = () => {
  const services = [
    {
      title: 'Home Based Care',
      description: 'We bring professional medical and supportive care to your home, ensuring comfort and quality care in a familiar environment.',
      image: homeBasedImage,
      link: '/core-services#home-based-care'
    },{
      title: 'Physiotherapy Services',
      description: 'Physiotherapy and rehabilitation programs designed to restore mobility and independence at home.',
      image: elderly1Image,
      link: '/core-services#physiotherapy-services'
    },
    {
      title: 'Lab Services',
      description: 'Comprehensive diagnostic laboratory services with home sample collection, rapid turnaround, and secure electronic reporting — including blood tests, biochemistry, microbiology, and routine screenings.',
      image: labImage, // temporary: uses existing image until ambulance photo is added
      link: '/core-services#lab-services'
    },
    {
      title: 'Elderly Care',
      description: 'We specialize in providing compassionate and comprehensive Elderly Care services that allow seniors to age gracefully in their own homes.',
      image: elderlyImage,
      link: '/core-services#elderly-care'
    },
    {
      title: 'Palliative Care',
      description: 'We offer specialized Palliative Care services focused on providing comfort and support to individuals facing serious illnesses.',
      image: palliativeImage,
      link: '/core-services#palliative-care-services'
    },
    {
      title: 'Doctor Home Visit',
      description: 'Doctor Home Visit services, bringing expert medical care directly to your doorstep.',
      image: doctorVisitImage,
      link: '/core-services#doctor-home-visit-services'
    }
  ];

  return (
    <section className="main-services-section" id="services">
      <Container>
        <div className="section-header text-center mb-5">
          <h2 className="section-title">Our Core Services</h2>
          <p className="section-subtitle">Comprehensive Home Care Solutions Tailored to Your Needs</p>
        </div>
        
        <Row className="g-4">
          {services.map((service, index) => (
            <Col key={index} lg={4} md={6}>
              <Card className="service-card h-100">
                <div className="service-image-wrapper">
                  <Card.Img variant="top" src={service.image} alt={service.title} />
                </div>
                <Card.Body className="d-flex flex-column">
                  <Card.Title>{service.title}</Card.Title>
                  <Card.Text className="flex-grow-1">{service.description}</Card.Text>
                  <Button as={Link} to={service.link} className="read-more-btn mt-2" aria-label={`Read more about ${service.title}`}>
                    Read More
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default MainServices;
